module.exports = __webpack_public_path__ + "img/telegram.eba29ea.svg";